import { gql } from "@apollo/client"
import { InjectedOptions, useMutation } from "@oysterhr/core"
import { ChangeAccountInput, ChangeAccountPayload } from "@oysterhr/schema"

export interface ChangeAccountMutationData {
  changeAccount: ChangeAccountPayload
}

const USER_UPDATE_PROFILE_PAGE_DATA = gql`
  mutation userUpdateProfilePageData(
    $userId: String!
    $name: String
    $preferredName: String
    $avatarSignedId: String
  ) {
    changeAccount(
      input: {
        userId: $userId
        name: $name
        preferredName: $preferredName
        avatarSignedId: $avatarSignedId
      }
    ) {
      user {
        id
        name
        preferredName
        email
        avatarUrl
      }
      errors
    }
  }
`

export const useChangeAccount = (
  options: InjectedOptions<ChangeAccountMutationData, ChangeAccountInput>,
) =>
  useMutation<ChangeAccountMutationData, ChangeAccountInput>(USER_UPDATE_PROFILE_PAGE_DATA, {
    ...options,
  })
